




import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPCertificate, VipCertificateType } from "@/loader";

@Component
export default class CertificateIcon extends Vue {
	@Prop({ type: VIPCertificate, default: null })
	public item!: VIPCertificate | null;

	@Prop({ type: String, default: null })
	public type!: VipCertificateType | null;

	public get _type(): VipCertificateType {
		return this.item ? this.item.type : this.type;
	}

	public get icon(): string[] {
		switch (this._type) {
			case VipCertificateType.workCertificate: return ["fas", "award"];
			case VipCertificateType.abilityCertificate: return ["fas", "signature"];
			default: return ['fas', 'question'];
		}
	}
}
